// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "3cfc9e281d4172d9530f424d5e6870db" + ".js";
};